<template>
    <div class="body">
        <div class="search-container">
            <div class="search-box">
<!--                <div class="input-box">-->
<!--                    <span class="title">年 级：</span>-->
<!--                    <el-date-picker-->
<!--                            v-model="grade"-->
<!--                            type="year"-->
<!--                            value-format="yyyy"-->
<!--                            placeholder="请选择年级"-->
<!--							@change="getData">-->
<!--                    </el-date-picker>-->
<!--                </div>-->
                <div class="input-box">
                    <span class="title">专 业：</span>
                    <el-select v-model="majorId" filterable clearable placeholder="请选择专业" @change="selectgetData">
                        <el-option
                                v-for="item in majorList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="btn-box margin-left-30">
                <el-button class="primary-btn" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="getData()">查询</el-button>
            </div>
        </div>

        <div class="table-box">
            <el-table
                    :data="tableData"
                    border
                    :cell-style="{color:'#666666',fontSize:'14px'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}"
                    align='center'
                  >
                <el-table-column
                        fixed
                        prop="grade"
                        label="年级"
                        width="100"
                        align='center'
                >
                </el-table-column>
                <el-table-column prop="level" align='center' label="层次"></el-table-column>
                <el-table-column
                        prop="name"
                        label="专业名称"
                        align='center'
                >
<!--                    <template slot-scope="scope">-->
<!--                        {{majorHash[scope.row.id]}}-->
<!--                    </template>-->
                </el-table-column>

                <el-table-column prop="org" align='center' label="所属院校" v-if="accountOrg == 1">
                    <template slot-scope="scope">
                        {{orgHash[scope.row.org]}}
                    </template>
                </el-table-column>
                <el-table-column label="排课详情" align='center'>
                    <template slot-scope="scope">
                        <el-button class="primary-btn" @click="preview(scope.row)">排课详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        align='center'
                >
                    <template slot-scope="scope">
                        <div class="handle-btn">
                            <el-button class="primary-btn" @click="edit(scope.row)">排课</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page=pageIndex
                        :page-size=10
                        :total=pageTotal
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <div class="preview-box">
            <el-dialog  :close-on-click-modal='false' :close-on-press-escape='false'
                    title="排课详情"
                    :visible.sync="previewVisible"
                    width="1000px"
                    :before-close="previewClose">
                <el-form ref="form" :model="form" label-width="70px" >
                    <el-form-item class="form-item" label-width="54px" label="年级：" prop="grade" >
                        <el-input class='page-input'  placeholder="请输入年级" v-model="form.grade" disabled style="width: 392px"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item"  label-width="54px" label="专业：" prop="name">
                        <el-input class='page-input' placeholder="请输入专业" v-model="form.name" disabled style="width: 392px"></el-input>
                    </el-form-item>
                    <div style="margin-left: 54px" v-for="(item,index) in previewData">
                        <div class="semester-title">
                            {{majorSemester[1][item.semester]}}
                        </div>
                        <div class="crs-content">
                            <div class="crs-box" v-for="(it,idx) in item.crs_list">
                                <div class="crs-sort-num">
                                    {{it.sort_num}}
                                </div>
                                <div class="crs-name">
                                    <div v-if='it.other_name '>
                                        {{ it.other_name }}
                                    </div>
                                    <div v-else>
                                        {{ crsDataHash[it.crs_id] }}

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closePreview()">关 闭</el-button>
                </span>
            </el-dialog>
        </div>

        <div class="dialog-box">
            <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
                    title="排课详情"
                    :visible.sync="dialogVisible"
                    width="70%"
                    :before-close="dialogClose">
                <el-form ref="form" :model="form" label-width="70px" :disabled="form.org != accountOrg">
                    <el-form-item class="form-item" label-width="54px" label="年级：" prop="grade" style='margin-right: 76px'>
                        <el-input class='page-input'  placeholder="请输入年级" disabled v-model="form.grade"  style="width: 100%"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item"  label-width="54px" label="专业：" prop="name" style='margin-right: 76px'>
                        <el-input class='page-input' placeholder="请输入专业" disabled v-model="form.name" style="width: 100%"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item"  label-width="54px" label="学期：" prop="name" style='margin-right: 76px'>
                        <el-select v-model="form.semester"
                                   placeholder="请选择学期"
                                   class="dialog-box-select"
                                   @change="changeSemester"
                                   style="width: 100%"
                        >
                            <el-option
                                    v-for="item in majorSemesterList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-item" style="margin-top: -8px" label-width="54px" label="排课：">
                        <div v-for="(item,index) in form.arrangementOption" class="dialog-box-select" >
                            <el-input-number v-model="item.sort_num"
                                             controls-position="right"
                                             :controls="false"
                                             :min="1"
                                             :max="99"
                                             style="width: 70px;"
                                             @change="checkSortNum"
                            ></el-input-number>
                            <el-select v-model="item.crs_id" class='dialog-box-input'
                                       placeholder="请选择专业课程"
                                       filterable
                                       @change="changeCrs"
                            >
                                <el-option
                                        v-for="item in crsData"
                                        :key="item.id"
                                        :label="item.o_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <span>类型：</span>
                            <el-select v-model="item.course_type" class='dialog-box-input'
                                       placeholder="请选择课程类型"
                                       filterable
                                       @change="changeCrs"
                            >
                                <el-option
                                    v-for="item in courseType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span>别名：</span>
                            <el-input class='dialog-box-input' v-model='item.other_name'></el-input>
                            <span>学分：</span>
                            <el-input class='dialog-box-input' v-model='item.course_score'></el-input>
                            <el-button type="danger" size='mini' style="margin-left: 15px;" @click="delArrangementOption(index)">删除</el-button>
                        </div>
                        <div style='margin-right: 76px'>
                            <el-button class="add-option" @click="addArrangementOption()">添加课程</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style='margin-right: 20px'>
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="save" :disabled="form.org != accountOrg">排 课</el-button>
                </span>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import { getTransitionValue } from '@/api/commonApi.js'
    export default {
        components:{getTransitionValue},
        name: 'TemplatePage',
        data() {
            return {
                previewVisible:false,
                previewData:[],
                delList:[],
                majorDataIndex:0,
                lastMajorDataIndex:0,
                majorData:[],
                semester:'',
                majorSemester:[],
                courseType:[],
                majorSemesterList:[],

                crsDataHash:[],
                crsData:[],
                dialogVisible:false,
                getDataStatus:1,
                pageIndex: 1,
                pageTotal:0,
                grade:'',
                searchData:'',
                majorList:[],
                majorHash:[],
                majorId:'',
                value: '',
                content:'',
                tableData: [],
                orgList:[],
                orgHash:[],
                accountOrg:0,
                form:{
                    grade:'',
                    name:"",
                    semester:1,
                    arrangementOption:[{
                        id:-1,
                        crs_id:'',
                        sort_num:1,
                        other_name:'',
                        course_score:0,
                        course_type:2,
                    }]
                },
            }
        },
        created() {
            this.accountOrg = localStorage.getItem("org");
            this.getTblInfo()
            this.getData()
            this.getTransitionValue()
            this.getCrsData()
        },
        methods:{
            checkSortNum(e){
                if (!e){
                    this.$message.error('序号不能为空')
                }
            },
            preview(data){
                this.getPreviewData(data.id)
                this.form.grade = data.grade
                this.form.name = data.name
            },
            getPreviewData(id){
                this.$get(this.BASEURL + `/arrangement/management?major_id=${id}&option=2`).then((res) => {
                    if (res.code === 200) {
                        this.previewData = res.data
                        let arr = []
                        this.previewData.forEach((item,index)=>{
                            if(item.crs_list.length !== 0){
                                arr.push(item)
                            }
                        })
                        this.previewData = arr

                        if(this.previewData.length === 0){
                            this.$message.error('暂无排课信息！')
                        }else{
                            this.previewVisible = true
                        }

                        console.log('this.previewData', this.previewData);
                    } else {
                        console.log(res.error);
                    }
                });
            },
            //dialog选择课程触发
            changeCrs(e){
                console.log(e);

                this.majorData[this.majorDataIndex].crs_list = this.form.arrangementOption
            },
            //dialog选择学期触发
            changeSemester(e){
                let isNull = false
                this.form.arrangementOption.forEach((item,index)=>{
                    this.lastMajorDataIndex = this.majorDataIndex
                    if(!item.crs_id || !item.sort_num){
                        isNull = true
                        if(!item.crs_id){
                            this.$message.error('请选择专业课程')
                        }
                        if(!item.sort_num){
                            this.$message.error('请输入排课序号')
                        }
                    }else{
                        isNull = false
                    }
                })
                if(isNull){
                    this.form.semester = this.lastMajorDataIndex + 1
                    return false
                }

                this.lastMajorDataIndex = this.majorDataIndex
                this.majorDataIndex = e - 1
                this.majorData[this.lastMajorDataIndex].crs_list = this.form.arrangementOption
                this.form.arrangementOption = this.majorData[this.majorDataIndex].crs_list
            },
            //获取排课列表
            getData(){
                //option 1 查询 2 获取编辑信息
                this.$get(this.BASEURL + `/arrangement/management?page=${this.pageIndex}&option=1&grade=${this.grade}&major=${this.majorId}`).then((res) => {
                    if (res.code === 200) {
                        this.tableData=res.data;
                        this.pageTotal = res.total
                    } else {
                        console.log(res.error);
                    }
                });
                console.log('222222222222222');
            },
            //触发搜索
            selectgetData(){
                this.pageIndex = 1
                this.getData()
            },
            //获取专业排课信息
            getMajorData(id){
                //option 1 查询 2 获取编辑信息
                this.$get(this.BASEURL + `/arrangement/management?major_id=${id}&option=2`).then((res) => {
                    if (res.code === 200) {
                        this.majorData = res.data
                        if(res.data[0] !== []){
                            this.form.arrangementOption = res.data[0].crs_list
                            //动态改变学期
                            let i = this.majorSemester[0].length - this.majorData.length
                            this.majorSemesterList = JSON.parse(JSON.stringify(this.majorSemester[0]))
                            this.majorSemesterList.splice(this.majorData.length,i)
                        }
                        console.log('getMajorData',this.majorSemesterList);
                        console.log('getMajorData222222222222222',res);
                    } else {
                        console.log(res.error);
                    }
                });
            },
            //获取专业列表
            getTblInfo(){
                this.$post(this.BASEURL+'/assets/table/info',{
                    tbl_list:[['id','grade,level,name','major_base_t'],['org','org_name','academy_base_t'],['org','org_name','academy_base_t']],
                    state:1
                }).then((res)=>{
                    if(res.code === 200){
                        this.majorList = res.data[0][0]
                        this.majorHash = res.data[0][1]
                        this.orgList = res.data[1][0]
                        this.orgHash = res.data[1][1]
                    }else{
                        console.log(res.error);
                    }
                })
            },
            //获取课程列表
            getCrsData() {
                this.$get(this.BASEURL+'/tution/course/GET').then((res)=>{
                    if(res.code === 200){
                        this.crsData = res.crsData
                        let hash = []

                        this.crsData.forEach((item,index)=>{
                            hash[item.id] = item.name + item.cls_name
                        })

                        this.crsDataHash = hash

                    }else{
                        console.log(res.error);
                    }
                });

            },
            //获取转换值列表
            getTransitionValue(){
                let data = ['major_semester','course_type']
                this.$post(
                    this.BASEURL + '/assets/transition/GET', {
                        'key_list': data
                    }).then((res) => {
                    if (res.code === 200) {
                        console.log('post',res.data)
                        this.majorSemester = res.data.major_semester
                        this.courseType = res.data.course_type[0]

                    } else {
                        console.log(res.error);
                    }
                });
            },
            edit(data){
                this.getMajorData(data.id)
                this.lastMajorDataIndex = 0
                this.majorDataIndex = 0
                this.form.grade = data.grade
                this.form.name = data.name
                this.form.semester = 1
                this.form.org = data.org
                this.arrangementOption = []
                this.del_list = []
                this.dialogVisible = true
            },
            save(){
                let isNull
                this.majorData.forEach((item,index)=>{
                    item.crs_list.forEach((it,id)=>{
    // 这里学期列表majorSemesterList
                        if(!it.crs_id || !it.sort_num){
                            isNull = true
                            if(!it.crs_id){
                                this.$message.error(`${this.majorSemesterList[index].label}还未选择专业课程！`)
                            }
                            if(!it.sort_num){
                                this.$message.error(`${this.majorSemesterList[index].label}排课序号为空！`)
                            }
                            return false
                        }
                    })
                })
                if(isNull){
                    return false
                }

                this.$put(this.BASEURL + `/arrangement/management`,{'data':this.majorData,'del_list':this.delList}).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(`排课成功！`);
                        this.dialogVisible = false
                    } else {
                        console.log(res.error);
                    }
                });
            },
            addArrangementOption(){
                let arrLength = this.form.arrangementOption.length;
                this.form.arrangementOption.push({
                    id:-1,
                    crs_id:'',
                    sort_num:arrLength+1,
                    other_name: '',
                    course_score:0,
                    course_type:2,
                })
            },
            delArrangementOption(index){
                console.log('index',index);
                this.form.arrangementOption.forEach((item,idx)=>{
                    if(item.id !== -1 && index === idx) {
                        this.delList.push(item.id)
                    }
                })
                console.log('this.delList',this.delList);
                this.form.arrangementOption.splice(index, 1)
            },
            //dialog关闭操作
            dialogClose(){
                this.dialogVisible = false
            },
            previewClose(){
                this.previewVisible = false
            },
            reset(){
                this.majorId = ''
                this.grade = ''
                this.getData();
            },
            handlePageChange(val) {
                this.pageIndex = val
                this.getData();
            },
            cancel() {
                this.dialogVisible = false;
                this.form = {
                    grade:'',
                        name:"",
                        semester:'',
                        arrangementOption:[{
                        crs:'',
                        sort:'1',
                        course_score:0,
                        course_type:2,
                    }]
                }
            },
            closePreview(){
                this.previewVisible = false
            }
        }
    };
</script>

<style lang="scss" scoped>
    /*/deep/.el-dialog__header{*/
    /*    border-bottom:1px solid #EFEFEF;*/
    /*}*/
    .body{
        button{
            padding: 8px 15px;
            font-size: 14px;
        }
    }
    /deep/.el-dialog__body{
        padding-left: 40px;
        padding-right: 40px;
    }

    /deep/.el-dialog__body .el-input-number .el-input .el-input__inner{
        border-radius: 5px 0px 0px 5px!important;
        border-right: none;
    }
    .form-item{
        margin-bottom: 10px;
    }
    .dialog-box-select{
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .dialog-box-input{
            flex-grow: 1;
            width: 50px;
        }
        span{
            white-space: nowrap;
            margin-left: 10px;
        }
    }
    /deep/.dialog-box-select .el-select .el-input .el-input__inner{
        border-radius: 0 5px 5px 0;
    }


    $radius:4px;

    .search-container{
        padding: 28px 30px;
        margin-top: $distance;
        margin-bottom: $distance;
        border-radius: $radius;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        /*justify-content: space-between;*/
        .search-box{
            /*width: 80%;*/
            display: flex;
            align-items: center;
            &>div{
                display: flex;
                align-items: center;
                min-width: 70px;
                span{
                    white-space: nowrap;
                }
            }
            .search-input {
                flex-grow: 1;
                margin-right: 16px;
            }
            .input-box{
                /*margin-top: 6px;*/
                /*margin-bottom: 6px;*/
                //margin-right: 26px;
                .input{
                    width: 230px;
                }
                .title{
                    font-size:14px;
                    color:$title-color;
                }
                select{
                    width: 230px;
                }
            }

            .input-other-box{
                /*margin-top: 10px;*/
                display: flex;
                align-items: center;
                flex-wrap: wrap;


            }
        }
        .btn-box{
            width: 20%;
            display: flex;
        }
    }
    .table-box{
        background-color: #ffffff;
        padding: 28px 30px;
        overflow-y:auto;
        border-radius: $radius;

    }
    .handle-btn{
        /*display: flex;*/
        /*align-items: center;*/
        button{
            margin: 4px;
        }

    }
    .primary-btn{
        border-color: #409EFF;
        color: #409EFF;
    }
    .add-option{
        margin-top: 10px;
        width: 100%;
    }
    .semester-title{
        margin-top: 10px;
        width:78px;
        height:32px;
        background-color:#EAF2FF;
        border-radius:3px 22px 24px 3px;
        color: #3377FF;

        font-size:12px;
        font-weight:500;
        line-height:32px;
        text-align: center;
    }
    .crs-content{
        display: flex;
        flex-wrap: wrap;
        .crs-box{
            width: 412px;
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            color: #666666;
            line-height:32px;
            .crs-sort-num{
                text-align: center;
                width: 56px;
                border: 1px solid #CBCBCB;
                border-right: none;
                border-radius: 5px 0 0 5px;
            }
            .crs-name{
                border-radius: 0 5px 5px 0;

                text-align: center;
                margin-right: 20px;
                width: 100%;
                border: 1px solid #CBCBCB;

            }
        }
    }



</style>
